import React from 'react';

import { STAFF_ASSIGNMENTS_LIST_QUERY_KEY } from '../../Organization/Assignments/queryKeys';
import { AssignmentsListPage } from '../../shared/assignments';

const QUEUE_CATEGORY = 'StaffAssignmentQueueNames';

export const StaffAssignmentsList: React.FC = () => {
  return (
    <AssignmentsListPage
      title="Assignments"
      queryKeyBase={STAFF_ASSIGNMENTS_LIST_QUERY_KEY}
      displayTypePrefKey="StaffAssignments"
      showOrganization={true}
      showOrganizationFilter={true}
      linkContext="staff"
      queueCategory={QUEUE_CATEGORY}
    />
  );
};
